module.exports = __webpack_public_path__ + "img/9.60ce6b9c.jpg";